module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAMCAYAAABbayygAAAAAXNSR0IArs4c6QAAASZJREFUGBljmDlz5rSFCxcKM0ABkN80d+5cdRgfRjNxcHC0/vjxYzpQAT9IkJOTs/Pv378N8+bNU4IpAtFM8fHxT5mZmUsZGRlnrVq1iicuLu4rFxdX+p8/f9qBimVhihlhjDlz5qj8+/ev+f///8np6enfli5dKvjly5eZQPl8IP85XCFIA9B6DaDJNTIyMsleXl4/gXwRIH86CwtLFhPMRBAN1HkD6Izux48fT4Hy37CysuYCnTEHRSFIEuiRSCC1AcQGAaAiP6Bz9kJ4UHLWrFmNQBwME5w9e3Yc0PoyGB9MAwWrgIJRMEGghjAgvxbGB9NAwSIgToIJAjX5AxW1wvhgGiiYDVSUBRMEBpMHUFEPjA+ngYJucA6QAdToCnQ8SrCB5AGDZX6F0QBQ2AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Shape.png
// module id = 704
// module chunks = 1